<template>
    <div v-if="!showEmailVerification">
        <form @submit.prevent="register">
            <TextField
                ref="email"
                :placeholder="$t('general.email')"
                :label="$t('general.email')"
                type="email"
                v-model="email"
                padding
                required
                class="mb-1"
            />
            <p class="subtitle gray-color">
                {{ $t('shared.loginModule.registerForm.recommendation') }}
            </p>
            <TextField
                type="password"
                :placeholder="$t('general.password')"
                :label="$t('general.password')"
                v-model="password"
                padding
                margin
                required
            />
            <TextField
                type="password"
                :placeholder="$t('general.confirmPassword')"
                :label="$t('general.confirmPassword')"
                padding
                v-model="confirmedPassword"
                margin
                required
                :helperText="errorMessage"
                :error="errorMessage !== ''"
            />
            <BaseButton class="w-100 pa-2 mt-4" variant="primary" type="submit">
                {{ $t('shared.loginModule.registerForm.register') }}
            </BaseButton>
        </form>
    </div>
    <VerifyEmail v-else :email="email" v-on:stateChange="changeState" />
</template>

<script>
import states from '../states';
import { emailVerificationURL } from '~/utils/urlUtils';
import { registerErrorMapper as errorMapper } from '~/utils/errors/authErrorMapper';

// Components
import VerifyEmail from './VerifyEmail';

export default {
    name: 'RegisterForm',
    components: { VerifyEmail },
    props: {
        value: Boolean,
        state: String,
    },
    data: () => ({
        email: '',
        password: '',
        confirmedPassword: '',
        errorMessage: '',
        showEmailVerification: false,
    }),
    methods: {
        setLoading(value) {
            this.$emit('input', value);
        },
        register() {
            if (this.password !== this.confirmedPassword) {
                this.errorMessage = this.$t(
                    'shared.loginModule.registerForm.passwordsNotMatch'
                );
                return;
            }

            this.setLoading(true);
            this.$interfaces.user
                .post({
                    body: {
                        email: this.email,
                        password: this.password,
                        emailReturnUrl: emailVerificationURL(),
                    },
                })
                .then(async () => {
                    this.$emit('register');
                    this.showEmailVerification = true;
                })
                .catch(error => {
                    this.errorMessage = errorMapper(error);
                    this.$emit('input', false);
                });
        },
        changeState(state) {
            this.$emit('stateChange', state);
        },
        focusOnEmail() {
            this.$nextTick(() => {
                this.$refs.email.focus();
            });
        },
    },
    computed: {
        credentials() {
            return this.email + this.password + this.confirmedPassword;
        },
    },
    watch: {
        credentials() {
            this.errorMessage = '';
        },
        state(newVal) {
            if (newVal === states.REGISTER) {
                this.showEmailVerification = false;
                this.email = '';
                this.password = '';
                this.confirmedPassword = '';
            }
        },
    },
};
</script>

<style scoped>
.outline {
    border-width: 1px;
    border-style: solid;
    border-radius: 0.25rem;
    border-color: rgba(0, 0, 0, 0.4);
}
.hdivider {
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    width: 1px;
    height: 36px;
}
.email-wrapper {
    background-color: white;
}
</style>

<style>
.reg-searchable-email {
    padding: 14px 14px 14px 0 !important;
    height: 50px !important;
}
.reg-input-email {
    text-align: end;
}
</style>
